import { render, staticRenderFns } from "./CaliperDetailsHoursComponent.vue?vue&type=template&id=4ec871fc&scoped=true"
import script from "./CaliperDetailsHoursComponent.js?vue&type=script&lang=js&external"
export * from "./CaliperDetailsHoursComponent.js?vue&type=script&lang=js&external"
import style0 from "./CaliperDetailsHoursComponent.vue?vue&type=style&index=0&id=4ec871fc&prod&lang=scss&scoped=true"
import style1 from "./CaliperDetailsHoursComponent.vue?vue&type=style&index=1&id=4ec871fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec871fc",
  null
  
)

export default component.exports